"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gotoPage = exports.downloadApp = exports.is58App = exports.getImei = exports.addDarkModel = exports.isDark = exports.isNativePage = exports.judge58Version = exports.goto = exports.resetReturnFun = exports.setReturnUrl = exports.open58App = void 0;
/**
 * 58app内常用函数集
 */
var methods_1 = require("../appMethods/methods");
Object.defineProperty(exports, "open58App", { enumerable: true, get: function () { return methods_1.open58App; } });
Object.defineProperty(exports, "setReturnUrl", { enumerable: true, get: function () { return methods_1.setReturnUrl; } });
Object.defineProperty(exports, "resetReturnFun", { enumerable: true, get: function () { return methods_1.resetReturnFun; } });
Object.defineProperty(exports, "goto", { enumerable: true, get: function () { return methods_1.goto; } });
Object.defineProperty(exports, "judge58Version", { enumerable: true, get: function () { return methods_1.judge58Version; } });
Object.defineProperty(exports, "isNativePage", { enumerable: true, get: function () { return methods_1.isNativePage; } });
Object.defineProperty(exports, "isDark", { enumerable: true, get: function () { return methods_1.isDark; } });
Object.defineProperty(exports, "addDarkModel", { enumerable: true, get: function () { return methods_1.addDarkModel; } });
Object.defineProperty(exports, "getImei", { enumerable: true, get: function () { return methods_1.getImei; } });
var is58App = function () {
    // 当前页面是否是在58app/同镇内里打开
    // let ua = navigator.userAgent.toLowerCase(),
    //   flag = false;
    // if (ua && ua.indexOf('wuba') != -1) {
    //   flag = true;
    // }
    // return flag;
    var flag = methods_1.getAppType() != "browser";
    return flag;
};
exports.is58App = is58App;
var downloadApp = function () {
    // 下载58车app
    // let ua = navigator.userAgent;
    // let isIos, isAndroid;
    // let Android =
    //   ua.indexOf("Android") > -1 ||
    //   ua.indexOf("Adr") > -1 ||
    //   ua.indexOf("Linux"), //android终端
    //   Ipad = ua.match(/(iPad).*OS\s([\d_]+)/), //ios终端
    //   Itouch = !Ipad && ua.match(/(iPod\s?[Ttouch]{5})[a-zA-Z\s;]*([\d_]+)/),
    //   Iphone = !Ipad && !Itouch && ua.match(/(iPhone\sOS)\s([\d_]+)/);
    // isIos = Iphone || Itouch || Ipad ? true : false;
    // isAndroid = Android > -1 ? true : false;
    // let url = isAndroid
    //   ? "//icon.xgo-img.com.cn/cheandroid/18122114/58Che_android_Newest.apk"
    //   : isIos
    //     ? "//itunes.apple.com/cn/app/58%E8%BD%A6/id1108830743"
    //     : "";
    // return url;
    return methods_1.download58cheApp();
};
exports.downloadApp = downloadApp;
// export const open58App = ({
//   //强制以58APP打开
//   type = "protocol",
//   title = document.title,
//   url = window.location.href,
// } = {}) => {
//   let targetUrl;
//   if (is58App()) {
//     return false;
//   }
//   if (type == "protocol") {
//     //调起制定协议
//     let data = encodeURIComponent(
//       JSON.stringify({ url: url, title: title, pagetype: "common" })
//     );
//     let a = encodeURIComponent("wbmain://jump/core/common?params=" + data);
//     targetUrl =
//       "https://down.58.com/zt/callappback.html?type=protocol&jumper=" + a;
//   } else {
//     //调起指定H5页面
//     url = encodeURIComponent(url);
//     title = encodeURIComponent(title);
//     targetUrl =
//       "https://down.58.com/zt/callappback.html?url=" + url + "&title=" + title;
//   }
//   window.location.href = targetUrl;
// };
// export const setReturnUrl = (url: any) => {
//   /**没有来源页时，返回按钮强制跳到url */
//   if (typeof url == "undefined" || document.referrer) {
//     return false;
//   }
//   if (typeof WBAPP != 'undefined') {
//     WBAPP.action.deviceEvent("goback", function () {
//       //没有来源页强制跳转到主会场
//       window.location.replace(url);
//     });
//   }
// };
// export const resetReturnFun = (callback: () => void) => {
//   /**重置58app返回按钮功能*/
//   if (!is58App() || typeof WBAPP == "undefined") {
//     return false;
//   }
//   WBAPP.action.deviceEvent("goback", function () {
//     callback();
//   });
// };
// /**
//  * 58app内链接跳转
//  * @param {string} url 跳转链接 可以是 协议wbmain：//   h5链接   相对路径
//  * @param {boolean} preventDefault 是否屏蔽默认行为 默认值是true
//  */
// const addFromHost = ['58che.com', '58.com']//追加from参数的域名
// export const goto = (url: any, preventDefault = true) => {
//   url = url.trim();
//   let isAddFromHost = addFromHost.filter(item => {
//     return url.split('?')[0].indexOf(item) != -1 || url.indexOf("//") == -1 || url.indexOf('wbmain://') != -1
//   }).length != 0;
//   if (is58App() && isAddFromHost) {
//     if (preventDefault) {
//       //@ts-ignore
//       event.preventDefault();
//     }
//     if (url.indexOf("wbmain://") != -1) {
//       WBAPP.invoke("pagetrans", {
//         protocol: url,
//       });
//     } else {
//       if (url.indexOf("//") == -1) {
//         url = "//" + window.location.hostname + url;
//       }
//       if (isAddFromHost && url.indexOf("from=") == -1 && getUrlParam("from")) {
//         let fromStr =
//           getUrlParam("from").indexOf("#") != -1
//             ? getUrlParam("from").substr(0, getUrlParam("from").indexOf("#"))
//             : getUrlParam("from");
//         url = setUrlParam({ url, params: { from: fromStr } });
//       }
//       WBAPP.action.pagetrans("core", {
//         pagetype: "common",
//         url: url,
//       });
//     }
//   }
// };
/*
 * 跳转监控
 * @param {Element} el dom元素
 * 跳转到车系页的判断基准：
    1、el元素是否包含data-type=='lineLink' data-native属性
    2、is58App()&&typeof WBAPP!='undefined' &&app 版本>10.8
  符合以上条件则跳转到native页 data-native
  否则通过goto跳转
*/
var gotoPage = function (el) {
    var nativeUrl = typeof el.getAttribute("data-native") == "undefined"
        ? ""
        : el.getAttribute("data-native"), url = typeof el.getAttribute("href") == "undefined"
        ? ""
        : el.getAttribute("href");
    if (exports.is58App() &&
        typeof WBAPP != "undefined" &&
        el.getAttribute("data-type") == "lineLink" &&
        nativeUrl) {
        // @ts-ignore
        event.preventDefault();
        methods_1.judge58Version("10.8.0").then(function () {
            methods_1.goto(nativeUrl, false);
        }, function () {
            methods_1.goto(url, false);
        });
    }
    else if (url) {
        methods_1.goto(url);
    }
};
exports.gotoPage = gotoPage;
/**
 * 判断58app版本是否高于versionNum
 * @param {string} versionNum  对比的版本号形如 9.10.0
 */
// export const judge58Version = (versionNum = '') => {
//   return new Promise<void>((resolve, reject) => {
//     if (!versionNum || !(is58App() && typeof WBAPP != 'undefined')) {
//       reject();
//     }
//     const arr = versionNum.split('.'),
//       v1 = parseInt(arr[0]),
//       v2 = typeof arr[1] == 'undefined' ? 0 : parseInt(arr[1]),
//       v3 = typeof arr[2] == 'undefined' ? 0 : parseInt(arr[2]);
//     WBAPP.action.getUserInfo("version", function (version: string) {
//       const versionArr = version.split("."),
//         cv1 = parseInt(versionArr[0]),
//         cv2 = typeof versionArr[1] == 'undefined' ? 0 : parseInt(versionArr[1]),
//         cv3 = typeof versionArr[2] == 'undefined' ? 0 : parseInt(versionArr[2]);
//       if (
//         cv1 < v1 ||
//         (cv1 == v1 && cv2 < v2) || (cv1 == v1 && cv2 == v2 && cv3 < v3)
//       ) {
//         //当前版本低于versionNum
//         reject();
//       } else {
//         //当前版本高于versionNum
//         resolve();
//       }
//     });
//   })
// }
// export const isNativePage = getUrlParam("nativeEmbed"); //是不是native内嵌页
// export const isDark = getUrlParam("dark"); //通过url地址参数判断是不是暗黑模式
// /**
//  * 暗黑模式下为body添加dark 类名
//  * 判断暗黑模式的依据
//  * 1、通过url里面参数 dark=1 是暗黑模式
//  * 2、协议wbmain打开此页面时，且协议配置中userInterfaceStyle=true时，手机及58app均开始深色模式时
//  */
// export const addDarkModel = (cn = "dark") => {
//   let x = window.matchMedia("(prefers-color-scheme: dark)");
//   if (isDark) {
//     //暗黑模式
//     document.getElementsByTagName("body")[0].classList.add(cn);
//     return;
//   }
//   if (is58App()&& typeof WBAPP != 'undefined') {
//     WBAPP.invoke("toggle_userinterfacestyle", {
//       userInterfaceStyle: "0",
//     });
//     _darkModelFun();
//     x.addListener(_darkModelFun); // 状态改变时添加监听器 模式修改的时候触发
//   }
//   function _darkModelFun() {
//     if (x.matches) {
//       // 媒体查询
//       //暗黑模式
//       document.getElementsByTagName("body")[0].classList.add(cn);
//     } else {
//       //明亮模式
//       document.getElementsByTagName("body")[0].classList.remove(cn);
//     }
//   }
// };
// /**
//   * 获取58app设备信息
//  */
// export const getImei = () => {
//   return new Promise((resolve, reject) => {
//     if (is58App() && typeof WBAPP != 'undefined') {
//       WBAPP.invoke('get_user_info', {
//         key: ''
//       }, function (resp: any) {
//         let obj = JSON.parse(resp);
//         let id = obj.platform == 'android' ? obj.imei : obj.openudid;
//         resolve(id);
//       })
//     } else {
//       reject('非58app环境')
//     }
//   })
// }
